import { createVoltraComponent } from './createVoltraComponent.js'
import type { GroupBoxProps } from './props/GroupBox.js'

export type { GroupBoxProps }
export const GroupBox = createVoltraComponent<GroupBoxProps>('GroupBox')
